module.exports = __webpack_public_path__ + "img/bth_bed_left_nor.8ec76670.png";